import { computed, Injectable, signal } from '@angular/core';
import { SolText } from '@sol/components';
import { type LabBannerMood } from '../../components/lab-banner/lab-banner.component';
import { LabAction } from '../../tools/lab-action';

@Injectable({ providedIn: 'root' })
export class LabBannerHostService {
  // App-shell banners must live above navigation and content. Pages control
  // this host instead of rendering their own top-level banner inside the route.
  public readonly active = signal<boolean>(false);
  public readonly mood = signal<LabBannerMood>('info');
  public readonly heading = signal<string | undefined>('Scan complete');
  public readonly description = signal<string | undefined>('We found 3 new exposures in your staging environment.');
  public readonly actionText = signal<string | undefined>('View details');
  public readonly secondaryActionText = signal<string | undefined>(undefined);
  public readonly dismissible = signal<boolean>(true);
  public readonly visible = signal<boolean>(false);
  public readonly action = computed<LabAction | undefined>(() => this.toAction(this.actionText()));
  public readonly secondaryAction = computed<LabAction | undefined>(() => this.toAction(this.secondaryActionText()));

  public reset(): void {
    this.active.set(false);
    this.visible.set(false);
    this.mood.set('info');
    this.heading.set('Scan complete');
    this.description.set('We found 3 new exposures in your staging environment.');
    this.actionText.set('View details');
    this.secondaryActionText.set(undefined);
    this.dismissible.set(true);
  }

  private toAction(value: string | undefined): LabAction | undefined {
    const text = value?.trim();
    return text ? { text: SolText.ofRaw(text) } : undefined;
  }
}
